import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_mes_services_ia(langs) {
  let translations;
  try {
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error("Erreur lors du chargement des traductions pour la langue", langs, error);
    return;
  }

  const tour = guide_tour_init();
  const t = translations.ia.mesServices;

  // Étape 1 — Bouton nouvelle génération
  guide_tour_step_start(tour, translations, t.nouvelle.titre, t.nouvelle.texte, "#btn_nouvelle_generation", "bottom");

  // Étape 2 — Onglets En cours / Terminées
  guide_tour_step(tour, translations, t.onglets.titre, t.onglets.texte, "#barreNavigation_servicesIA", "bottom");

  // Étape 3 — Table des générations en cours
  guide_tour_step_complete(tour, translations, t.liste.titre, t.liste.texte, "#liste_servicesIA_enCours", "top");

  tour.start();
}
